import React from 'react'
import './styles.css'
interface LabelProps {
    text: string
}

export default function Label(props: LabelProps): JSX.Element {

    return (
        <div tabIndex={0} className="label-wrapper">
            <p className="label">{props.text}</p>
        </div>
    )
}